import partenaires from '../img/partenaires.png'
import reasons from '../img/reasons.png'
import insurtech from '../img/insurtech.png'
import google from '../img/google.svg'
import star from '../img/étoile.svg'
import crazywoman from '../img/femme au telephone.jpg'
import telephone from '../img/telephone.png'
import leftarrow from '../img/flèche CTA retour.svg'

const Customer = (p) => <div className="customer">
    <h1>{p.name}</h1>
    <img className="google" src={google}/>
    <div className="stars"><img src={star}/><img src={star}/><img src={star}/><img src={star}/><img src={star}/></div>
    <p>
        {p.children}
    </p>
</div>

export default (p) => <div className="footer">
    <div className="narrow">
    <h1>
        Des tarifs <b>ultra-compétitifs</b><br/>Les tarifs les moins chers
        de France sur de nombreuses cibles et véhicules !
    </h1>
    <h2>Assur Bon Plan est recommandé par l’ensemble des
    comparateurs d’assurance pour ses tarifs imbattables</h2>
    <img className="banner" src={partenaires}/>

    <h1>
        Pourquoi 30 000 clients ont choisi <b>Assur Bon Plan ?</b>
    </h1>
    <img className="banner" src={reasons}/>

    <div className="twothird">
        <h1>
        Assur Bon Plan expert de
            l’assurance digitale<br/> <b>membre d'InsurTech France !</b>
        </h1>
        <img src={insurtech}/>
    </div>

    <h1>
    Que pensent <b>nos clients</b> de nous ?
    </h1>
    <h2>
        Ils donnent leur avis !
    </h2>
    <div className="customers">
        <Customer name="Adrien Chabrier">
        Assuré depuis 1 an pour ma moto, je
        suis très satisfait, tarif avantageux par
        rapport à mon précédent assureur,
        service réactif.
        </Customer>
        <Customer name="Thierry Milland">
        Assuré depuis 1 an pour ma moto, je
        suis très satisfait, tarif avantageux par
        rapport à mon précédent assureur,
        service réactif.
        </Customer>
        <Customer name="Madepielo34">
        Assuré depuis 1 an pour ma moto, je
        suis très satisfait, tarif avantageux par
        rapport à mon précédent assureur,
        service réactif.
        </Customer>
    </div>
    <div className="help_woman">
        <div>
            <img src={crazywoman}/>
        </div>
        <div>
            <h1>Vous souhaitez de <b>l’aide</b> pour finalisez votre souscription ?</h1>
            <p>Appelez-nous !</p>
            <a href="tel:0974772861"><img src={telephone}/>09 74 77 28 61</a>
            <p>Nos conseillers sont à votre écoute pour vous aider
            dans vos démarches du lundi au vendredi de 9h à 18h</p>
        </div>
    </div>
    <h3>
        Nous contacter par mail : <a href="mailto:devis@assurbonplan.fr">devis@assurbonplan.fr</a>
    </h3>
    </div>
    <div className="white">
        <div className="headbox headleftaction">
            <div onClick={()=>p.setPage('vehicule')}>
                    <img src={leftarrow}/>
                    Modifier mes <br/> informations
            </div>
        </div>
        <div className="legal">
        ASSUR GOOD DEAL - 37 rue Rouget de Lisle - 92700 Colombes - France -  
        <br/>
        Intermédiaire en assurances R.C.S. 535 120 760 NANTERRE
        <br/>
        Immatriculée à l’ORIAS sous le n° 11 063 984 – www.orias.fr
        <br/>
        Entreprise soumise au contrôle de l’Autorité de Contrôle Prudentiel et de
        <br/>
        Résolutions (ACPR)4 Place de Budapest – 75009 Paris
        </div>
    </div>
</div>